module.exports = __webpack_public_path__ + "static/4-2-add08823e775605f48f0c0db5ab103d6.png";